import { Button } from '@mantine/core'
import { AlertTriangle } from 'lucide-react'
import { useRouter, type ErrorComponentProps } from '@tanstack/react-router'

/**
 * The shared route-level failure surface (ADR 0027): rendered by the router when a route
 * loader throws anything that is not a redirect. "Try again" re-runs the failed loader via
 * `router.invalidate()` — the route's own pending state takes over from there.
 */
export function RouteError({ error }: ErrorComponentProps) {
  const router = useRouter()
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.75rem',
        minHeight: '40vh',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <AlertTriangle size={28} color="var(--accent-ink)" aria-hidden />
      <div style={{ fontWeight: 600, color: 'var(--text-primary)' }}>
        This page couldn't load
      </div>
      <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', maxWidth: '32rem' }}>
        {error instanceof Error && error.message ? error.message : 'Something went wrong.'}
      </div>
      <Button variant="light" onClick={() => void router.invalidate()}>
        Try again
      </Button>
    </div>
  )
}
